import React, { useState,useEffect } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  // NavLink as NavL,
} from "reactstrap";
import { NavLink } from "react-router-dom";

export const PortfolioNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const [token, setToken] = useState("");
  useEffect(() => {
    setToken(localStorage.getItem("token"))
  }, []);

  return (
    <div>
      <Navbar
        light
        expand="lg"
        style={{
          backgroundColor: "#fff",
          borderColor: "#fff",
          paddingTop: "10px",
          paddingLeft: "15px",
          borderRadius: "20px",
          boxSizing: "border-box",
        }}
      >
        <NavbarBrand           href={token ? "/?token=" + token : ""}
 style={{ color: "#4941A7" }}>
          Price Risk Management Tool
        </NavbarBrand>
        <NavbarToggler onClick={toggle} className="mr-2" />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem className="ml-5 mr-2">
              <NavLink
                to="/about"
                style={{ color: "#4941A7", textDecoration: "none" }}
                activeStyle={{
                  color: "#000",
                  textDecoration: "underline",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Crop-Market Eligibility
              </NavLink>
            </NavItem>
            {/* PolicyDashboard */}
            <NavItem className="ml-4 mr-2">
              <NavLink
                to="/portfolioDashboard"
                style={{ color: "#4941A7", textDecoration: "none" }}
                activeStyle={{
                  color: "#000",
                  textDecoration: "underline",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Current Portfolio
              </NavLink>
            </NavItem>
            <NavItem className="ml-4 mr-2">
              <NavLink
                to="/simulation"
                style={{ color: "#4941A7", textDecoration: "none" }}
                activeStyle={{
                  color: "#000",
                  textDecoration: "underline",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Historical Portfolio
              </NavLink>
            </NavItem>

            <NavItem className="ml-4 mr-2">
              <NavLink
                to="/reports"
                style={{ color: "#4941A7", textDecoration: "none" }}
                activeStyle={{
                  color: "#000",
                  textDecoration: "underline",
                  fontSize: "15px",
                  fontWeight: "bold",
                }}
              >
                Reports
              </NavLink>
            </NavItem>
          </Nav>

          {/* Logout */}
          {/* <NavL onClick={signOut}>
            <BiLogOutCircle size="23px" style={{ color: "#4941A7" }} />
          </NavL> */}
        </Collapse>
      </Navbar>
    </div>
  );
};
